import React from "react";
import styled from "styled-components";

export const CALL_BACK_TIMEZONES = [
  { value: "UTC-8", label: "PT – Pacific (UTC-8)" },
  { value: "UTC-7", label: "MT – Mountain (UTC-7)" },
  { value: "UTC-6", label: "CT – Central (UTC-6)" },
  { value: "UTC-5", label: "ET – Eastern (UTC-5)" },
  { value: "UTC-4", label: "ATL – Atlantic (UTC-4)" },
  { value: "UTC-3", label: "South America (UTC-3)" },
];

export function readCallBackSchedule(callDetails = {}) {
  const desc = callDetails.call_back_time_desc;
  return {
    time: typeof desc === "string" ? desc.trim() : "",
    timezone:
      typeof callDetails.call_back_timezone === "string"
        ? callDetails.call_back_timezone.trim()
        : "",
  };
}

export function applyCallBackSchedule(
  updatedObj,
  { dontCallBack, callBackTime, callBackTimezone }
) {
  updatedObj.dont_call_back = dontCallBack ? 1 : 0;
  updatedObj.call_back_time_desc = callBackTime || "";
  updatedObj.call_back_timezone = (callBackTimezone || "").trim();
  return updatedObj;
}

const withCurrentValue = (options, currentValue) => {
  if (!currentValue || options.some((option) => option.value === currentValue)) {
    return options;
  }
  return [{ value: currentValue, label: currentValue }, ...options];
};

const CallBackScheduleFields = ({
  timeId,
  timezoneId,
  callBackTime,
  callBackTimezone,
  onTimeChange,
  onTimezoneChange,
  ministryOptions = [],
  disabled = false,
}) => {
  const timeOptions = withCurrentValue(
    ministryOptions.map((option) => ({
      value: String(option.value ?? ""),
      label: option.label,
    })),
    callBackTime
  );
  const timezoneOptions = withCurrentValue(
    CALL_BACK_TIMEZONES,
    callBackTimezone
  );

  return (
    <div className="row">
      <div className="col-md-6 mb-2">
        <label htmlFor={timeId} className="form-label">
          <Labelspan>Call Back Time</Labelspan>
        </label>
        <select
          id={timeId}
          className="form-select"
          value={callBackTime || ""}
          onChange={(e) => onTimeChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">Choose Call Back Time</option>
          {timeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-6 mb-2">
        <label htmlFor={timezoneId} className="form-label">
          <Labelspan>Timezone</Labelspan>
        </label>
        <select
          id={timezoneId}
          className="form-select"
          value={callBackTimezone || ""}
          onChange={(e) => onTimezoneChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">Choose Timezone</option>
          {timezoneOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const Labelspan = styled.span`
  color: #000;
  font-family: "Space Grotesk";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3.5px;
`;

export default CallBackScheduleFields;
